import React, {
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
} from "react";
import { AuroraIconProps, Sizes } from "./AuroraIcon";
import styles from "../styles.module.scss";

type Components = Record<
  string,
  ForwardRefExoticComponent<AuroraIconProps & RefAttributes<SVGSVGElement>>
>;

const sizeMap: Sizes = {
  xs: "16",
  s: "24",
  m: "32",
  l: "56",
};

const OpenOutline16 = forwardRef<SVGSVGElement, AuroraIconProps>((props, ref) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width="16"
    height="16"
    className={[styles.auIcon, styles.auIcon16, "auIcon", "auIcon16", props.className].join(" ")}
    focusable={false}
    ref={ref}
  >
    <path d="M8 2v2h2.59l-3.3 3.29 1.42 1.42L12 5.41V8h2V2z" />
    <path d="M10 12H4V6h3V4H2v10h10V9h-2z" />
  </svg>
));

const OpenOutline24 = forwardRef<SVGSVGElement, AuroraIconProps>((props, ref) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    className={[styles.auIcon, styles.auIcon24, "auIcon", "auIcon24", props.className].join(" ")}
    focusable={false}
    ref={ref}
  >
    <path d="M17 19H5V7h6V5H3v16h16v-8h-2z" />
    <path d="M14 3v2h3.59l-6.3 6.29 1.42 1.42L19 6.41V10h2V3z" />
  </svg>
));

const OpenOutline32 = forwardRef<SVGSVGElement, AuroraIconProps>((props, ref) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="32"
    height="32"
    className={[styles.auIcon, styles.auIcon32, "auIcon", "auIcon32", props.className].join(" ")}
    focusable={false}
    ref={ref}
  >
    <path d="M23 26H6V9h9V7H4v21h21V17h-2z" />
    <path d="M18 4v2h6.59l-9.3 9.29 1.42 1.42L26 7.41V14h2V4z" />
  </svg>
));
;

const components: Components = { "16": OpenOutline16,
"24": OpenOutline24,
"32": OpenOutline32 };

const OpenOutlineComponent: ForwardRefExoticComponent<
  AuroraIconProps & RefAttributes<SVGSVGElement>
> = forwardRef<SVGSVGElement, AuroraIconProps>(
  (
    {
      size = OpenOutline.getSizes().includes("s")
        ? "s"
        : OpenOutline.getSizes()[0],
      ...rest
    },
    ref
  ) => {
    try {
      const Tag = components[sizeMap[size] || parseInt(size)];
      if (!Tag) {
        console.error(
          `The icon OpenOutline does not have the size "${size}".`
        );
        return <React.Fragment />;
      }
      return <Tag {...rest} ref={ref} />;
    } catch (e) {
      console.error(
        `The icon OpenOutline does not have the size "${size}".`,
        e
      );
      return <React.Fragment />;
    }
  }
);

const OpenOutline = Object.assign(OpenOutlineComponent, {
  getSizes: (): string[] => ["xs", "s", "m"],
});

export default OpenOutline;
